export enum ESize {
  LARGE = 'large',
  MEDIUM = 'medium',
  MIN = 'min',
  NONE = 'none',
}
